import React from 'react';
interface PullQuoteProps {
  children: React.ReactNode;
}
export function PullQuote({
  children
}: PullQuoteProps) {
  return <div className="font-lora text-[clamp(20px,3.5vw,26px)] font-semibold italic leading-[1.4] text-black my-11 py-7 px-8 border-l-4 border-teal bg-cream max-[600px]:px-[22px] max-[600px]:py-[22px]" data-id="element-34">
      {children}
    </div>;
}